"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadHelper = void 0;
class DownloadHelper {
    static getFilePath(file) {
        return `${this.uploadPath}${file.filename}`;
    }
}
exports.DownloadHelper = DownloadHelper;
DownloadHelper.uploadPath = '/uploads/';
